import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-burial-details-cm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-burial-details-cm.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ViewBurialDetailsCmConstants } from "./view-burial-details-cm.constants";
import { SaShortDatePipe } from "../../../../shared/pipes/sa-short-date/sa-short-date.pipe";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { forkJoin } from "rxjs";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { take } from "rxjs/operators";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { MapService } from "../../../../map/shared/map.service";
import { MapServiceService } from "../../../../map/shared/map-service.service";
let ViewBurialDetailsCmComponent = class ViewBurialDetailsCmComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    mapService;
    mapServiceService;
    requestStatusService;
    appController;
    changeDetectorRefs;
    saShortdatePipe;
    routerParamsService;
    burialTypeControl = ViewBurialDetailsCmConstants.BURIAL_TYPE_CONTROL;
    burialTypeLabel = ViewBurialDetailsCmConstants.BURIAL_TYPE_LABEL;
    burialDateControl = ViewBurialDetailsCmConstants.BURIAL_DATE_CONTROL;
    burialDateLabel = ViewBurialDetailsCmConstants.BURIAL_DATE_LABEL;
    burialTypePlaceHolder = ViewBurialDetailsCmConstants.BURIAL_TYPE_PH;
    validationMessages = ViewBurialDetailsCmConstants.VALIDATION_MESSAGES;
    burialDescriptionControl = ViewBurialDetailsCmConstants.DESCRIPTION_CONTROL;
    burialDescriptionLabel = ViewBurialDetailsCmConstants.DESCRIPTION_LABEL;
    cemeteryControl = ViewBurialDetailsCmConstants.CEMETERY_CONTROL;
    cemeteryLabel = ViewBurialDetailsCmConstants.CEMETERY_LABEL;
    cemeteryPlaceHolder = ViewBurialDetailsCmConstants.CEMETERY_PLACE_HOLDER;
    title = ViewBurialDetailsCmConstants.STEP_TITLE;
    burialTypes = [];
    graves = [];
    cemeteries = [];
    defaultGraveStatus = [];
    defaultCemetery = {
        cemeteryObjectId: null,
        cemeteryName: ViewBurialDetailsCmConstants.DEFAULT_CEMETERY_NAME,
        cemeteryId: null
    };
    burialForm;
    getLookupsObservableSubscription;
    checkMapLayersSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, mapService, mapServiceService, requestStatusService, appController, changeDetectorRefs, saShortdatePipe, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.mapService = mapService;
        this.mapServiceService = mapServiceService;
        this.requestStatusService = requestStatusService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.saShortdatePipe = saShortdatePipe;
        this.routerParamsService = routerParamsService;
    }
    ngOnInit() {
        this.initForm();
        this.loadLookup();
        this.getMetadata();
    }
    loadMetadata(stepMeta) {
    }
    handleRouteChange() {
    }
    initForm() {
        this.burialForm = this.aflaModuleStrategyService.form.get("burialForm");
    }
    populateForm(application) {
        this.burialForm.get(this.burialTypeControl).setValue(application.type);
        this.burialForm.get(this.burialDescriptionControl).setValue(application.description);
        this.burialForm.get(this.burialDescriptionControl).disable();
        this.burialForm.get(this.burialTypeControl).disable();
        if (application.burialDate !== undefined && application.burialDate !== null) {
            const dateString = this.saShortdatePipe.transform(application.burialDate);
            this.burialForm.get(this.burialDateControl).setValue(dateString);
        }
        this.burialForm.get(this.burialDateControl).disable();
        let cemetery = this.defaultCemetery;
        this.cemeteries.forEach(item => {
            if (item.cemeteryId === application.cemeteryId) {
                cemetery = item;
            }
        });
        this.burialForm.get(this.cemeteryControl).setValue(cemetery);
        this.burialForm.get(this.cemeteryControl).disable();
    }
    loadLookup() {
        this.getLookupsObservableSubscription = this.applicationViewService.getLookupsObservable({ $filter: `moduleId eq ${this.appController.selectedModuleID} and (name eq 'ApplicationType' or name eq 'DefaultGraveStatus') and deleted eq false` }).subscribe(response => {
            const applicationTypes = [];
            const defaultGraveStatus = [];
            if (response && response.value.length > 0) {
                response.value.forEach(item => {
                    if (item.name === "ApplicationType") {
                        applicationTypes.push(JSON.parse(item.content));
                    }
                    if (item.name === "DefaultGraveStatus") {
                        defaultGraveStatus.push(JSON.parse(item.content));
                    }
                });
            }
            applicationTypes.sort((a, b) => a.value.localeCompare(b.value));
            defaultGraveStatus.sort((a, b) => a.value.localeCompare(b.value));
            this.aflaModuleStrategyService.lookups.set("applicationTypes", applicationTypes);
            this.aflaModuleStrategyService.lookups.set("defaultGraveStatus", defaultGraveStatus);
            this.burialTypes = applicationTypes;
            this.defaultGraveStatus = defaultGraveStatus;
            this.getCemeteries();
        });
    }
    getCemeteries() {
        this.requestStatusService.showBusySpinner("Getting maps...");
        this.applicationViewService.getCemeterySelectionModuleMaps(+this.appController.selectedModuleID).pipe(take(1)).subscribe({
            next: (moduleMapsResult) => {
                const moduleMaps = moduleMapsResult.value;
                let cemeteryModuleMap = null;
                let graveModuleMap = null;
                for (const moduleMap of moduleMaps) {
                    if (moduleMap.selectionLayerType === "Cemetery") {
                        cemeteryModuleMap = moduleMap;
                    }
                    if (moduleMap.selectionLayerType === "Grave") {
                        graveModuleMap = moduleMap;
                    }
                }
                if (cemeteryModuleMap !== null && graveModuleMap !== null) {
                    const gravesIds = this.defaultGraveStatus.map(item => `GraveStatus='${item.value}'`);
                    const gravesQueryWhere = gravesIds.join(" or ");
                    const gravesQueryReturnGeometry = false;
                    const gravesQueryOutFields = "CemeteryID";
                    const gravesQueryReturnDistinctValues = true;
                    const cemeteryQueryWhere = `1=1`;
                    const cemeteryQueryReturnGeometry = false;
                    const cemeteryQueryOutFields = "*";
                    const proxyUrl = ApiProxyConstants.URL;
                    let graveQueryUrl = "";
                    if (graveModuleMap.url.endsWith("/")) {
                        graveQueryUrl = "query";
                    }
                    else {
                        graveQueryUrl = "/query";
                    }
                    const graveUrl = `${graveModuleMap.url}${graveQueryUrl}?where=${gravesQueryWhere}&returnGeometry=${gravesQueryReturnGeometry}&outFields=${gravesQueryOutFields}&returnDistinctValues=${gravesQueryReturnDistinctValues}&f=json`;
                    let cemeteryQueryUrl = "";
                    if (cemeteryModuleMap.url.endsWith("/")) {
                        cemeteryQueryUrl = "query";
                    }
                    else {
                        cemeteryQueryUrl = "/query";
                    }
                    const cemeteryUrl = `${cemeteryModuleMap.url}${cemeteryQueryUrl}?where=${cemeteryQueryWhere}&returnGeometry=${cemeteryQueryReturnGeometry}&outFields=${cemeteryQueryOutFields}&f=json`;
                    const proxyGavesUrl = `${proxyUrl}?${encodeURIComponent(graveUrl)}`;
                    const proxyCemeteryUrl = `${proxyUrl}?${encodeURIComponent(cemeteryUrl)}`;
                    forkJoin([this.applicationViewService.queryMapViaProxy(proxyCemeteryUrl, cemeteryModuleMap.id),
                        this.applicationViewService.queryMapViaProxy(proxyGavesUrl, graveModuleMap.id)])
                        .pipe(take(1))
                        .subscribe({
                        next: data => {
                            const cemeteryFeatureSet = data[0];
                            const gravesFeatureSet = data[1];
                            if (gravesFeatureSet?.features?.length > 0) {
                                const gravesIds = gravesFeatureSet.features.map(item => this.propertyDataAlternateColumnName(item.attributes, "CemeteryID", "cemeteryid"));
                                if (cemeteryFeatureSet?.features?.length > 0) {
                                    const filteredCemeteries = cemeteryFeatureSet.features
                                        .map(item => ({
                                        cemeteryName: this.propertyDataAlternateColumnName(item.attributes, "Name", "name"),
                                        cemeteryId: this.propertyDataAlternateColumnName(item.attributes, "OBJECTID", "objectid"),
                                        cemeteryObjectId: null
                                    }))
                                        .filter(cemetery => gravesIds.includes(cemetery.cemeteryId));
                                    this.cemeteries = [
                                        this.defaultCemetery,
                                        ...filteredCemeteries
                                    ];
                                    this.cemeteries = [
                                        this.cemeteries[0],
                                        ...this.cemeteries.slice(1).sort((a, b) => a?.cemeteryName?.localeCompare(b?.cemeteryName))
                                    ];
                                    this.aflaModuleStrategyService.lookups.set("cemeteries", this.cemeteries);
                                    this.populateForm(this.selectedApplication);
                                    this.changeDetectorRefs.detectChanges();
                                }
                            }
                            this.requestStatusService.removeBusySpinner("Getting cemeteries");
                        },
                        error: error => {
                            this.requestStatusService.removeBusySpinner("Getting cemeteries");
                            this.appController.handleServerErrorMessage(ViewBurialDetailsCmConstants.STEP_TITLE, error, CRUDOperation.Get);
                            this.populateForm(this.selectedApplication);
                        }
                    });
                }
                else {
                    this.requestStatusService.removeBusySpinner("Getting cemeteries");
                    this.populateForm(this.selectedApplication);
                }
            },
            error: (error) => {
                this.requestStatusService.removeBusySpinner("Getting cemeteries");
                this.appController.handleServerErrorMessage(ViewBurialDetailsCmConstants.STEP_TITLE, error, CRUDOperation.Get);
                this.populateForm(this.selectedApplication);
            }
        });
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: MapService },
        { type: MapServiceService },
        { type: RequestStatusService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: SaShortDatePipe },
        { type: RouterParamsService }
    ];
};
ViewBurialDetailsCmComponent = __decorate([
    Component({
        selector: "app-view-burial-details-cm",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewBurialDetailsCmComponent);
export { ViewBurialDetailsCmComponent };
